import React, { useState } from "react";
import { Icon } from "./Icon";
import { WebVideoArt } from "./WebVideoArt";
import { getApiBaseUrl } from "../../api/client";
import { SeriesListItem } from "../../api/series";

// A TV-show card. Visually a sibling of WebVideoCard, but tapping opens the
// show's info page (seasons + episodes) rather than starting playback.
export function WebSeriesCard({
  series,
  onOpen,
}: {
  series: SeriesListItem;
  onOpen: (s: SeriesListItem) => void;
}) {
  const [thumbErrored, setThumbErrored] = useState(false);
  const cat = series.categories[0] || "Show";
  const ageLabel = `${series.ageMin}–${series.ageMax}`;
  const posterSrc = (() => {
    if (!series.thumbUrl || thumbErrored) return null;
    return series.thumbUrl.startsWith("http")
      ? series.thumbUrl
      : `${getApiBaseUrl()}${series.thumbUrl}`;
  })();
  const epLabel = `${series.episodeCount} episode${series.episodeCount === 1 ? "" : "s"}`;
  return (
    <button
      className="w-card"
      onClick={() => onOpen(series)}
      style={{ width: "100%", minWidth: 0, maxWidth: "100%" }}
    >
      <div className="art">
        <WebVideoArt category={cat} />
        {posterSrc && (
          <img
            src={posterSrc}
            alt=""
            onError={() => setThumbErrored(true)}
            style={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              zIndex: 1,
            }}
          />
        )}
        {series.isPremium && (
          <div className="lock-badge">
            <Icon name="lock" size={14} />
          </div>
        )}
        {/* Marks the card as a multi-episode show. */}
        <div className="new-badge">SERIES</div>
      </div>
      <div className="meta">
        <div className="cat">{cat}</div>
        <div className="title">{series.title}</div>
        <div className="sub">
          <span>{epLabel}</span>
          <span className="dot" />
          <span>Age {ageLabel}</span>
          {series.isPremium && (
            <>
              <span className="dot" />
              <span style={{ color: "var(--primary-ink)", fontWeight: 800 }}>
                Kidly+
              </span>
            </>
          )}
        </div>
      </div>
    </button>
  );
}

export default WebSeriesCard;
